export function heatmapAnimation() {
  const container = document.getElementById("tenesys-block-heatmap-animation");
  if (!container) return;

  const inner = container.querySelector(".kt-inside-inner-col") || container;

  const canvas = document.createElement("canvas");
  inner.appendChild(canvas);

  const ctx = canvas.getContext("2d");

  let W, H;

  const COLS = 19;
  const TILE_H = 10;
  let ROWS, TILE_W;

  const PALETTE = ["#003CFF", "#184EFF", "#416DFF", "#8CA7FF", "#D4DEFF"];

  let currIdx = [];
  let nextIdx = [];
  let t = [];
  let dur = [];

  let lastTime = performance.now();
  let playing = true;

  function resize() {
    W = canvas.width = window.innerWidth;
    H = canvas.height = window.innerHeight;

    TILE_W = W / COLS;
    ROWS = Math.ceil(H / TILE_H);

    initFadeStates();
  }

  window.addEventListener("resize", resize);

  function pickNeighbor(idx) {
    if (idx === 0) return 1;
    if (idx === PALETTE.length - 1) return PALETTE.length - 2;
    return idx + (Math.random() < 0.5 ? -1 : 1);
  }

  function easeInOutSine(u) {
    return 0.5 - 0.5 * Math.cos(u * Math.PI * 2);
  }

  function initFadeStates() {
    currIdx = [];
    nextIdx = [];
    t = [];
    dur = [];

    for (let cx = 0; cx < COLS; cx++) {
      currIdx[cx] = [];
      nextIdx[cx] = [];
      t[cx] = [];
      dur[cx] = [];

      for (let ry = 0; ry < ROWS; ry++) {
        const start = Math.floor(Math.random() * PALETTE.length);
        currIdx[cx][ry] = start;
        nextIdx[cx][ry] = pickNeighbor(start);
        t[cx][ry] = Math.random();
        dur[cx][ry] = 0.8 + Math.random() * 1.4;
      }
    }
  }

  function draw(now) {
    requestAnimationFrame(draw);

    const dt = playing ? (now - lastTime) / 1000 : 0;
    lastTime = now;

    ctx.clearRect(0, 0, W, H);

    for (let ry = 0; ry < ROWS; ry++) {
      const y = ry * TILE_H;

      for (let cx = 0; cx < COLS; cx++) {
        const x = cx * TILE_W;

        t[cx][ry] += dt / dur[cx][ry];
        if (t[cx][ry] >= 1) {
          currIdx[cx][ry] = nextIdx[cx][ry];
          nextIdx[cx][ry] = pickNeighbor(currIdx[cx][ry]);
          t[cx][ry] = 0;
          dur[cx][ry] = 0.8 + Math.random() * 1.4;
        }

        const u = easeInOutSine(Math.min(t[cx][ry], 1));
        const c1 = PALETTE[currIdx[cx][ry]];
        const c2 = PALETTE[nextIdx[cx][ry]];

        ctx.fillStyle = lerpColor(c1, c2, u);
        ctx.fillRect(x, y, TILE_W + 1, TILE_H);
      }
    }
  }

  function lerpColor(a, b, t) {
    const ca = hexToRgb(a);
    const cb = hexToRgb(b);

    const r = Math.round(ca.r + (cb.r - ca.r) * t);
    const g = Math.round(ca.g + (cb.g - ca.g) * t);
    const bb = Math.round(ca.b + (cb.b - ca.b) * t);

    return `rgb(${r},${g},${bb})`;
  }

  function hexToRgb(hex) {
    const n = parseInt(hex.slice(1), 16);
    return {
      r: (n >> 16) & 255,
      g: (n >> 8) & 255,
      b: n & 255,
    };
  }

  window.addEventListener("keydown", (e) => {
    if (e.code === "Space") playing = !playing;
    if (e.key === "r" || e.key === "R") initFadeStates();
  });

  resize();
  requestAnimationFrame(draw);
}
